/**
 * Utility to ensure Google Maps API is loaded before use
 * @returns {Promise<void>}
 */
export const waitForGoogleMaps = () => {
  return new Promise((resolve) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const checkInterval = setInterval(() => {
      if (window.google && window.google.maps) {
        clearInterval(checkInterval);
        resolve();
      }
    }, 100);

    // Timeout after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
      console.error('Google Maps API failed to load within 10 seconds');
      resolve(); // Resolve anyway to prevent hanging
    }, 10000);
  });
};

/**
 * Check if Google Maps is currently available
 * @returns {boolean}
 */
export const isGoogleMapsLoaded = () => {
  return !!(window.google && window.google.maps);
};
